import { render, staticRenderFns } from "./salaryApproval.vue?vue&type=template&id=91cf086e&scoped=true&"
import script from "./salaryApproval.vue?vue&type=script&lang=js&"
export * from "./salaryApproval.vue?vue&type=script&lang=js&"
import style0 from "./salaryApproval.vue?vue&type=style&index=0&id=91cf086e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cf086e",
  null
  
)

export default component.exports